import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import type { Raffle } from "../../types/raffle";

const raffleService = {
	...createBaseService<Raffle>("/backoffice/case-raffles"),
	raffle: async (params = {}) => {
		const response = await apiClient.post("/backoffice/raffle", params);
		return response.data;
	},
	findByIdCaseId: async (id: string) => {
		const response = await apiClient.get<{ data: T }>(
			`/backoffice/case-raffles/${id}`,
		);

		return response.data.data;
	},
};

export default raffleService;
